/** Number copy for the Overview tab. One place, so every tile agrees. */

const COUNT = new Intl.NumberFormat("en-US");

/** 0.1333 -> "13.3%", 0 -> "0%", null -> "–". Rates are 0..1. */
export function formatPercent(rate) {
  if (rate === null || rate === undefined || Number.isNaN(Number(rate))) return "–";
  const pct = Number(rate) * 100;
  const text = pct.toFixed(1).replace(/\.0$/, "");
  return `${text}%`;
}

/** 2183 -> "2,183"; anything that is not a number -> "0". */
export function formatCount(n) {
  const value = Number(n);
  return COUNT.format(Number.isFinite(value) ? value : 0);
}

/** 4, 30 -> "4 of 30". */
export function formatRatio(num, den) {
  return `${formatCount(num)} of ${formatCount(den)}`;
}

/**
 * Booked plus transferred: a call handed to the clinic is a success exactly
 * like a booking. The backend sends `successes` directly; until it does, or
 * on an older response, the sum of the two is the same number.
 */
export function successesOf(obj) {
  const o = obj || {};
  if (o.successes !== null && o.successes !== undefined && Number.isFinite(Number(o.successes))) {
    return Number(o.successes);
  }
  return (Number(o.booked) || 0) + (Number(o.transferred) || 0);
}
